<div class="dialog-wrapper settings">
  <div class="dialog__header">
    <header l10nTranslate>exportAndSettings.settings</header>
    <mat-icon class="dialog-close" aria-hidden="false" mat-dialog-close>close</mat-icon>
  </div>
  <div class="dialog__contents">
    <form [formGroup]="settingsFormGroup">
      <div class="settings__content" formGroupName="displayOptions">
        <div class="opt-title" l10nTranslate>exportAndSettings.stackOptions</div>
        <div class="opt-content">
          <div class="checkbox-container">
            <mat-checkbox formControlName="showElevators" l10nTranslate> exportAndSettings.showElevators </mat-checkbox>
          </div>
        </div>
      </div>

      <!--  TODO: Need to implement floor options UI -->
      <!-- CSS Note: sample HTML added below for radio/checkbox -->
      <!--
      <div class="export__content" formGroupName="">
        <div class="opt-title" l10nTranslate>exportAndSettings.xxxxxx</div>
        <div class="opt-content">
          <div class="checkbox-container">
            <mat-checkbox formControlName="">
              exportAndSettings.xxxxxx
            </mat-checkbox>
          </div>
          <div class="radio-container">
            <mat-radio-group aria-label="Select xxx" formControlName="">
              <mat-radio-button *ngFor="let xxx of xxx" [value]="xxx">{{ xxx }}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
      -->

      <div class="settings__content" formGroupName="cardDetails">
        <div class="opt-title" l10nTranslate>exportAndSettings.toggleSpaceDetails</div>
        <div class="opt-content-wrapper">
          <div class="opt-content">
            <div class="checkbox-container">
              <mat-checkbox formControlName="suiteNumber" l10nTranslate> exportAndSettings.suiteNumber </mat-checkbox>
            </div>
            <div class="checkbox-container">
              <mat-checkbox formControlName="spaceSize" l10nTranslate> exportAndSettings.spaceSizeSFSM </mat-checkbox>
            </div>
            <div class="checkbox-container">
              <mat-checkbox formControlName="leaseEndingDate" l10nTranslate>
                exportAndSettings.leaseEndDate
              </mat-checkbox>
            </div>
            <div class="checkbox-container">
              <mat-checkbox formControlName="tenantRepAgency" l10nTranslate>
                exportAndSettings.tenantRepAgency
              </mat-checkbox>
            </div>
          </div>
          <div class="opt-content">
            <div class="tenant-rent-wrapper">
              <div class="checkbox-container">
                <mat-checkbox formControlName="showLeaseRate" l10nTranslate>
                  exportAndSettings.tenantRent
                </mat-checkbox>
              </div>
              <div class="radio-container" *ngIf="settingsFormGroup?.value?.cardDetails?.leaseRateOpts">
                <mat-radio-group formControlName="leaseRateOpts">
                  <mat-radio-button
                    *ngFor="let radioButton of leaseRateOptions"
                    [value]="radioButton.key"
                    l10nTranslate
                    >{{ radioButton.value }}</mat-radio-button
                  >
                </mat-radio-group>
              </div>
            </div>
            <div class="asking-rent-wrapper">
              <div class="checkbox-container">
                <mat-checkbox formControlName="rentDate" l10nTranslate>
                  exportAndSettings.askingRentCurrAvail
                </mat-checkbox>
              </div>
              <div class="asking-rent-container" *ngIf="settingsFormGroup?.value?.cardDetails?.rentDate">
                <div class="checkbox-container">
                  <mat-checkbox formControlName="includeEstimatedRates" l10nTranslate>
                    exportAndSettings.includeEstimatedRates
                  </mat-checkbox>
                </div>
                <div class="checkbox-container" *ngIf="settingsFormGroup?.value?.cardDetails?.includeEstimatedRates">
                  <mat-checkbox formControlName="includeEstimatedRateIndicator" l10nTranslate>
                    exportAndSettings.includeEstimatedRateIndicator
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="settings__content" formGroupName="colorScheme">
        <div class="opt-title" l10nTranslate>exportAndSettings.colorOptions</div>
        <div class="opt-content section__content">
          <div class="theme-options" *ngFor="let viewTheme of colorSchemeSettingsSection">
            <div class="theme-title">
              {{ viewTheme.value | xTranslate }}
            </div>
            <div class="options-container">
              <div class="theme-colors">
                <div
                  class="colored-button"
                  *ngFor="let theme of themeColors"
                  [ngClass]="[(colorSchemeFG?.controls)[viewTheme.key].value, theme]"
                ></div>
              </div>
              <div class="radio-container">
                <mat-radio-group class="" aria-label="Select a theme" [formControlName]="viewTheme.key">
                  <mat-radio-button *ngFor="let themeOption of themeOptions; let i = index" [value]="themeOption.key">{{
                    themeOption.value | xTranslate: { number: i + 1 }
                  }}</mat-radio-button>
                </mat-radio-group>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="button-container">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      (click)="saveSettings()"
      [disabled]="disableSaveButton"
      l10nTranslate
    >
      commonLabels.save
    </button>
  </div>
</div>
